import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-files-folder-error-icon',
  templateUrl: './files-folder-error.component.html'
})
export class FilesFolderErrorComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
